import { useState } from 'react';

import { TextField } from '@components/text-field';

import { useUpdateCompanyInfo } from 'api/companies/hooks';
import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';
import { Company } from 'types/companies';

import { SettingsModal } from './settings-modal';

type EditGoogleAnalyticsModalModalProps = ModalProps<{
  currentGaTracker: Company['gaTracker'];
}>;

export const EditGoogleAnalyticsModal = ({
  currentGaTracker,
}: EditGoogleAnalyticsModalModalProps) => {
  const { t } = useStore();
  const [gaTracker, setGaTracker] = useState(currentGaTracker ?? '');
  const submit = useUpdateCompanyInfo({
    successMessage: t('company.settings.root.ga.updateSuccess'),
    errorMessage: t('company.settings.root.ga.updateError'),
  });

  return (
    <SettingsModal
      title={t('company.settings.root.ga.title')}
      description={t('company.settings.root.ga.description')}
      onSave={() => submit.mutate({ gaTracker: gaTracker || null })}
      saveDisabled={submit.isLoading}
    >
      <TextField
        label={t('company.settings.root.ga.label')}
        placeholder="G-XXXXXXXXXX"
        value={gaTracker}
        onChange={setGaTracker}
      />
    </SettingsModal>
  );
};
